import Vue from 'vue'
import axios from 'axios'
import scrollTo from '../directives/scrollTo'
import eventHub from '../helpers/event-hub'

if (document.getElementById('vue-areas')) {
  new Vue({
    el: '#vue-areas',
    data() {
      return {
        apiUrl: `${location.origin}/wp-json/wp/v2/areas`,
        loading: true,
        areas: [],
        filters: {},
        selectedMap: '',
        selectedMapAlt: ''
      }
    },
    mounted() {
      this.getAreas()
    },
    computed: {
    },
    methods: {
        getAreas() {
        this.loading = true

        axios
            .get(this.apiUrl, {
            params: {
                lang: document.getElementById('vue-areas').dataset.lang
            }
            })
            .then(response => {
              this.areas = response.data;
              this.loading = false;
            });
        },
        getAreaThumbnail(area, size) {
            return area.acf.image.sizes[size]
        },
        getMore() {
            this.page++;
            this.getAreas()
        },
        openModal(name, map) {
            this.selectedMap = map.sizes.large
            this.selectedMapAlt = map.alt
            eventHub.$emit(`modal:${name}:open`)
        },
        closeModal(name) {
            this.selectedMap = ''
            this.selectedMapAlt = ''
            eventHub.$emit(`modal:${name}:close`)
        }
    },
    directives: {
      scrollTo
    }
  })

}
